export function isTeamLeader(user) {
  if (!user) return false;
  return Boolean(user.is_team_leader) || Number(user.management_id) === 1;
}

export function isMultimediaBureau(user) {
  if (!user) return false;
  return Number(user.bureau_id) === 3;
}

export function canManageGallery(user) {
  return isTeamLeader(user) || isMultimediaBureau(user);
}

export function canCreateGallery(user) {
  return canManageGallery(user);
}

export function canEditGallery(user) {
  return canManageGallery(user);
}

export function canDeleteGallery(user) {
  return canManageGallery(user);
}

export function normalizeGalleryPublicity(gallery) {
  return String(gallery?.publicity ?? '').trim().toLowerCase();
}

/**
 * Who can see a gallery in the internal list / details.
 * - public, private_view, private_access: any logged-in member (public also for guests on public routes only)
 * - private_edit (Managed): Team Leader & Multimedia only
 */
export function canViewGallery(user, gallery) {
  if (!gallery) return false;
  const publicity = normalizeGalleryPublicity(gallery);
  if (publicity === 'public') return true;
  if (!user) return false;
  if (canManageGallery(user)) return true;
  if (publicity === 'private_edit') return false;
  return true;
}

export function canAddPicturesToPrivateAccess(user, gallery) {
  if (!user || !gallery) return false;
  if (!canViewGallery(user, gallery)) return false;
  return normalizeGalleryPublicity(gallery) === 'private_access';
}
